goog.provide("shadow.js.shim.module$$base_ui$react$select$Select");
shadow.js.shim.module$$base_ui$react$select$Select = shadow.js.shim.module$$base_ui$react$select.Select;
